/**
 * Slugs of destinations that historically had a long-form guide blog page.
 * ─────────────────────────────────────────────────────────────────────
 * As of C2 Phase 2 the source of truth for whether a blog exists for a
 * given slug is the Postgres `destination_blogs` table (publish-filtered
 * via `/api/destination-blogs/:slug`). Client UI no longer reads this
 * list to gate visibility — see `useDestinationBlog` in
 * `client/src/hooks/use-destination-blog.ts`.
 *
 * The list itself is preserved because `shared/localized-slugs.ts` still
 * re-exports it for legacy callers (and for SEO-only static slug checks
 * in places that can't fetch). The 213 entries match the current DB
 * coverage. If you add a brand-new destination (DB row), this list does
 * not need to be updated for the public site to render the link.
 *
 * To regenerate this list from the DB:
 *   psql "$DATABASE_URL" -tA -c \
 *     "SELECT slug FROM destination_blogs WHERE is_published = true ORDER BY slug;"
 */
export const DESTINATION_BLOG_SLUGS: readonly string[] = [
  "bakar","baska","baska-draga","baska-voda","benkovac","betina","biograd-na-moru",
  "bjelovar","blato","bol","bozava","brela","brna","brod-na-kupi","brodarica",
  "brsecine","cakovec","cavtat","cres","crikvenica","dakovo","daruvar","delnice",
  "dobrinj","drage","drnis","drvenik","dubrovnik","dugi-otok","dugi-rat","durdjevac",
  "funtana","fuzine","glina","gospic","gracac","gradac","grebastica","hvar","icici",
  "igrane","ilok","ilovik","imotski","ist","jadrija","jastrebarsko","jelsa",
  "jesenice","jezera","kampor","kanica","karin","karlobag","karlovac","kastav",
  "kastela","klis","kneza","knin","kolan","kolocep","komiza","koprivnica","korcula",
  "korenica","kraljevica","krapina","krilo","krizevci","krk-town","kutina","labin",
  "lipik","lokva-rogoznica","lopar","lopud","lovran","lubenice","ludbreg","lumbarda",
  "makarska","mali-losinj","malinska","marina","martinscica","marusici","medulin",
  "metkovic","milna","mimice","mlini","molat","moscennicka-draga","mrkopalj",
  "murter","nasice","nerezine","nin","njivice","novalja","novi-vinodolski",
  "novigrad","obrovac","ogulin","olib","omis","omisalj","opatija","opuzen","orebic",
  "osijek","otocac","ozalj","pakostane","pakrac","pazin","petrcane","petrinja",
  "pisak","plat","plitvice-lakes","ploce","podgora","podstrana","porec","posedarje",
  "povljana","pozega","premuda","primosten","primosten-burnji","privlaka","pucisca",
  "pula","punat","rab","rabac","racisce","rastoke","razanac","razanj","rijeka",
  "rogoznica","rovinj","sali","samobor","selce","senj","sevid","sibenik","silba",
  "silo","sinj","sipan","sisak","skradin","slano","slavonski-brod","slunj",
  "smokvica","solin","split","stara-baska","stari-grad","starigrad-paklenica","ston",
  "sucuraj","sumartin","supetar","supetarska-draga","susak","sveti-filip-i-jakov",
  "tar-vabriga","tisno","tribunj","trilj","trogir","trpanj","trsteno","tucepi",
  "tuhelj","turanj","udbina","umag","unije","valun","varazdin","vela-luka",
  "veli-losinj","veli-rat","vinkovci","vir","virovitica","vis","vodice","vrana",
  "vrbnik","vrgorac","vrsar","vrsi","vukovar","zablace","zabok","zaboric","zadar",
  "zagreb","zaostrog","zapresic","zaton-dubrovnik","zaton-zadar","zivogosca",
  "zlatni-rat",
] as const;

const SLUG_SET = new Set<string>(DESTINATION_BLOG_SLUGS);

export function hasDestinationBlog(slug: string | undefined | null): boolean {
  return typeof slug === "string" && SLUG_SET.has(slug);
}
